// extracted by mini-css-extract-plugin
export var container = "style-module--container--c398f";
export var form = "style-module--form--bd8a2";
export var gift = "style-module--gift--2d99d";
export var info = "style-module--info--e311b";
export var reg = "style-module--reg--308dd";
export var textBlock = "style-module--text-block--52896";
export var timer = "style-module--timer--42e54";